// extracted by mini-css-extract-plugin
module.exports = {"confirm":"ConfirmDialog_confirm__2PDRD"};